import { Table, TableBody, TableCell, TableRow } from '@/components/Table/styles';
import { TableHeader } from '@/components/Table/TableHeader/TableHeader';
import { TableHeaderCell } from '@/components/Table/TableHeaderCell/TableHeaderCell';
import { TableConfigItemsListType } from '@/components/Table/types/types';
import noop from 'lodash/noop';

type DesktopTableType<T> = {
  config: TableConfigItemsListType<T>;
  items: T[];
  onRowClick?: (item: T) => void;
  isLoading: boolean;
  isClickableRow?: boolean;
};

export const DesktopTable = <T extends { id: string }>({
  config,
  items = [],
  onRowClick = noop,
  isLoading,
  isClickableRow = true,
}: DesktopTableType<T>) => {
  const hasItems = !!items.length && !isLoading;

  return (
    <Table>
      <TableHeader>
        {config.map(({ key, name, width, hasSort, header, tooltip }) => {
          return (
            <TableHeaderCell key={key} name={name} width={width} hasSort={hasItems && hasSort}>
              {tooltip}
              {header}
            </TableHeaderCell>
          );
        })}
      </TableHeader>
      <TableBody>
        {items.map((item: T) => {
          return (
            <TableRow key={item.id} onClick={() => onRowClick(item)} isClickableRow={isClickableRow}>
              {config.map(({ key, width, getValue }) => {
                const { value, title } = getValue(item);

                return (
                  <TableCell key={key} width={width} title={title}>
                    {value}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
